import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BehaviorSubject, Observable} from 'rxjs';
import {map, tap} from 'rxjs/operators';
import {environment} from '../../environments/environment';
import {Permission, UserPermission} from './permission.model';

@Injectable({
  providedIn: 'root'
})
export class PermissionService {

  private readonly permissions$ = new BehaviorSubject<ReadonlySet<string>>(new Set());

  constructor(private readonly httpClient: HttpClient) {
  }

  getUserPermissions = (): any => {
    const url = `${environment.baseUrl}users/permissions`;
    return this.httpClient.get<UserPermission[]>(url).pipe(
      tap(res => {
        if (res) {
          this.setUserPermissions(res);
        }
      }),
    );
  }

  setUserPermissions = (permissions: UserPermission[]) => {
    this.permissions$.next(new Set(permissions.map(p => p.name)));
  }

  hasUserPermission$ = (perm: Permission): Observable<boolean> => this.permissions$.pipe(
    map(perms => perms.has(perm))
  )

}
